// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@/assets/pattern-background.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Jost:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* @tokens Colors
* @presenter Color
*/
.brand-grey-400[data-v-085abf92] {
  color: #bdbdbd;
}
.brand-grey-500[data-v-085abf92] {
  color: #9e9e9e;
}
.brand-grey-600[data-v-085abf92] {
  color: #757575;
}
.brand-grey-700[data-v-085abf92] {
  color: #616161;
}
.status-error[data-v-085abf92] {
  color: #b00020;
}
.status-yellow[data-v-085abf92] {
  color: #aa8a22;
}
.status-success[data-v-085abf92] {
  color: #1eb980;
}
.status-success-grey-700[data-v-085abf92] {
  color: #616161;
}
.text-white[data-v-085abf92] {
  color: #fff;
}
.line[data-v-085abf92] {
  border: 1px solid #f4f2f7;
  margin-top: 2%;
  width: 100%;
  margin-bottom: 2%;
}
@media (max-width: 767px) {
.line[data-v-085abf92] {
    display: none;
}
}
@media (max-width: 767px) {
.mobile-line[data-v-085abf92] {
    border: 1px solid #f4f2f7;
    margin-right: 10%;
    width: 90%;
    margin-bottom: 2%;
}
}
.modal[data-v-085abf92] {
  left: 1%;
  position: relative;
  height: 100%;
  width: 98%;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  padding-top: 30px;
}
@media (max-width: 767px) {
.modal[data-v-085abf92] {
    display: block;
    height: 95%;
}
}
.modal-container[data-v-085abf92] {
  height: 7%;
  width: 94%;
  margin: 3%;
}
@media (max-width: 767px) {
.modal-container[data-v-085abf92] {
    height: 12%;
}
}
.modal-header[data-v-085abf92] {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: center;
  justify-content: space-between;
}
@media (max-width: 767px) {
.modal-header[data-v-085abf92] {
    height: 85%;
}
}
.modal-header-container[data-v-085abf92] {
  position: relative;
  width: 100%;
  height: 100%;
  border-bottom: 1px solid #f4f2f7;
  margin: 0;
}
@media (max-width: 767px) {
.modal-header-container[data-v-085abf92] {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    height: 100%;
}
}
.modal-header-container-subheading[data-v-085abf92] {
  display: none;
}
@media (max-width: 767px) {
.modal-header-container-subheading[data-v-085abf92] {
    display: inline-block;
    width: 100%;
    height: 25%;
    position: absolute;
    right: 0;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    align-content: flex-end;
    flex-wrap: wrap;
    text-align: center;
    padding-top: 0;
    top: 80%;
    left: 0;
}
.modal-header-container-subheading > .modal-header-text[data-v-085abf92] {
    font-size: 13px;
    white-space: nowrap;
}
}
@media (max-width: 767px) {
.modal-header-container-text[data-v-085abf92] {
    width: 100%;
    height: 95%;
    position: absolute;
    right: 0;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    align-content: flex-end;
    flex-wrap: wrap;
    text-align: center;
    padding-top: 0;
    top: 0;
    left: 0;
}
}
.modal-header-arrow[data-v-085abf92] {
  width: 10%;
  height: 100%;
  justify-content: center;
  cursor: pointer;
}
@media (max-width: 767px) {
.modal-header-arrow-image[data-v-085abf92] {
    width: 23px;
}
}
@media (max-width: 767px) {
.modal-header-arrow[data-v-085abf92] {
    z-index: 99999;
    padding-top: 0;
    width: 100%;
    height: 80%;
}
}
.modal-header-logo[data-v-085abf92] {
  display: none;
  width: 90%;
  height: 100%;
}
@media (max-width: 767px) {
.modal-header-logo[data-v-085abf92] {
    display: flex;
    width: 100%;
    height: 45%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    background-color: transparent;
    right: 0;
    justify-content: center;
    align-items: center;
}
}
@media (max-width: 767px) {
.modal-header-logo > img[data-v-085abf92] {
    width: 50%;
    height: 80%;
}
}
@media (max-width: 767px) {
.modal-header-progress[data-v-085abf92] {
    height: 95%;
    width: 100%;
    margin-top: 0;
    z-index: 0;
    position: absolute;
    background-color: transparent;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    align-content: flex-end;
    flex-wrap: wrap;
}
}
@media (max-width: 767px) and (max-width: 767px) {
.modal-header-progress > img[data-v-085abf92] {
    width: 15%;
    height: 20%;
}
}
.modal-header-text[data-v-085abf92] {
  width: 100%;
  height: 50%;
  color: #9e9e9e;
  margin-left: 2%;
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  font-family: Jost, sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0;
  text-align: center;
}
@media (max-width: 767px) {
.modal-header-text[data-v-085abf92] {
    margin-left: 0;
    display: contents;
    flex-direction: column;
    flex-wrap: nowrap;
    z-index: 0;
    background-color: transparent;
}
}
.modal-body[data-v-085abf92] {
  position: relative;
  height: 85%;
  width: 95%;
  text-align: center;
  font-family: Jost, sans-serif;
}
@media (max-width: 767px) {
.modal-body[data-v-085abf92] {
    width: 95%;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: 29px;
    margin-left: 2.5%;
}
}
.modal_text-input-container[data-v-085abf92] {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
}
.modal_text-input-container_title[data-v-085abf92] {
  width: 448px;
  height: 20px;
  font-family: Jost, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0;
  text-align: left;
  padding-bottom: 10px;
}
.modal_text-input-container_title > span[data-v-085abf92] {
  color: #757575;
  font-weight: 400;
}
.modal_text-input-container_single[data-v-085abf92] {
  width: 100%;
  margin-bottom: 15px;
}
@media (max-width: 767px) {
.modal_text-input-container_single[data-v-085abf92] {
    width: 95%;
}
}
.modal_text-input-container_double-column[data-v-085abf92] {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  width: 100%;
  margin-top: 0;
  padding-bottom: 15px;
}
@media (max-width: 767px) {
.modal_text-input-container_double-column[data-v-085abf92] {
    flex-direction: column;
    align-items: flex-start;
}
}
.modal_button-container[data-v-085abf92] {
  margin: 2% 0;
  height: 5%;
  display: flex;
  align-items: flex-end;
  width: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
}
@media (max-width: 767px) {
.modal_button-container[data-v-085abf92] {
    justify-content: center;
}
}
@media (max-width: 767px) {
.modal_button-container .yc--button[data-v-085abf92] {
    width: 100%;
}
}
@media (max-width: 767px) {
.logo[data-v-085abf92] {
    width: 100%;
    height: 100%;
}
}
body[data-v-085abf92] {
  margin: 0px;
  height: 100%;
}
html[data-v-085abf92] {
  padding: 0px;
  margin: 0px;
  font-family: "Jost", sans-serif;
  line-height: 1.5;
}
.view_component[data-v-085abf92] {
  margin: 0px;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: bottom;
  background-color: #2F1C50;
  padding-top: 72px;
  background-size: contain;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@media screen and (max-height: 800px) {
.view_component[data-v-085abf92] {
    padding-top: 15px;
}
}
.view_component-logo[data-v-085abf92] {
  padding-bottom: 50px;
}
@media screen and (max-height: 800px) {
.view_component-logo[data-v-085abf92] {
    padding-bottom: 5px;
}
}
@media (max-width: 768px) {
.view_component[data-v-085abf92] {
    background-color: #fff;
    background-image: none;
    padding-top: 0;
    min-height: 800px;
    overflow-y: scroll;
}
.view_component-logo[data-v-085abf92] {
    height: 30px;
    display: none;
}
}

/**
* @tokens Colors
* @presenter Color
*/
.verification-status-container[data-v-085abf92] {
  display: flex;
  flex-direction: column;
  margin: 20px 15px 0 15px;
  font-family: Jost, sans-serif;
  width: 100%;
  overflow-x: hidden;
}
.verification-status-header[data-v-085abf92] {
  display: flex;
  align-items: center;
  border-bottom: 2px solid #f4f2f7;
  padding: 5px 0 15px 0;
  margin: 0 0 15px 0;
}
@media (max-width: 767px) {
.verification-status-header[data-v-085abf92] {
    display: none;
}
}
.verification-status-header-logo > img[data-v-085abf92] {
  width: 180px;
  height: 35px;
}
.verification-status-header-arrow[data-v-085abf92] {
  cursor: pointer;
}
.verification-status-header-text[data-v-085abf92] {
  display: flex;
  justify-content: center;
  color: #9e9e9e;
  font-size: 18px;
  font-weight: 500;
  flex-grow: 1;
}
.verification-status-header-mobile[data-v-085abf92] {
  display: none;
}
@media (max-width: 767px) {
.verification-status-header-mobile[data-v-085abf92] {
    display: flex;
    border-bottom: 2px solid #f4f2f7;
    padding-bottom: 3px;
    margin: 15px 0;
}
}
.verification-status-header-mobile-left[data-v-085abf92] {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}
.verification-status-header-mobile-right[data-v-085abf92] {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
}
.verification-status-body[data-v-085abf92] {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.verification-status-body-header[data-v-085abf92] {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 22px;
  font-weight: 500;
  margin-bottom: 10px;
}
.verification-status-body-item[data-v-085abf92] {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 15px;
}
.verification-status-body-item > img[data-v-085abf92] {
  width: 24px;
  margin-top: 2px;
}
.verification-status-body-item-details[data-v-085abf92] {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.verification-status-body-item-details-title[data-v-085abf92] {
  font-size: 18px;
  font-weight: 400;
  color: #616161;
}
.verification-status-body-item-details-subtitle[data-v-085abf92] {
  font-size: 12px;
  font-weight: 400;
  color: #9e9e9e;
  margin-bottom: 5px;
}
.verification-status-body-item-details-error[data-v-085abf92] {
  font-size: 12px;
  font-weight: 400;
  color: #b00020;
  margin-bottom: 15px;
}
.verification-status-body-item-details-retry[data-v-085abf92] {
  font-size: 14px;
  font-weight: 500;
  color: #492b7c;
  cursor: pointer;
}
.loader-gif[data-v-085abf92] {
  animation: spin-085abf92 0.7s ease-in-out 0s infinite;
}
.mobile[data-v-085abf92] {
  display: none;
}
@media (max-width: 767px) {
.mobile[data-v-085abf92] {
    display: block;
}
}
@keyframes spin-085abf92 {
from {
    transform: rotate(0deg);
}
to {
    transform: rotate(360deg);
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
